import { render } from "./warGame.vue?vue&type=template&id=f2720f98&scoped=true"
import script from "./warGame.vue?vue&type=script&lang=js"
export * from "./warGame.vue?vue&type=script&lang=js"

import "./warGame.vue?vue&type=style&index=0&id=f2720f98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2720f98"]])

export default __exports__